import React, { useEffect, useState } from 'react';
import network from '../../../assets/sso/networks.svg';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { UserData } from '../../../types/user.types';
import { NETWORKS } from '../../../constants/networks.config';
import NetworkItem from '../../../components/NetworkItem';
const NetworkAdmin: React.FC = () => {
    const [users, setUsers] = useState<[UserData] | null>(null);
    const [totalUsers, setTotalUsers] = useState(0);
    const adminGroupement = useSelector((state: RootState) => state.user.groupement);
    const grpId = adminGroupement ? adminGroupement.id : '';
    const url = `/api/users?groupement.id=${String(grpId)}&isActive=1`;

    useEffect(() => {
        const fetchUser = async () => {
            const response = await axios.get(url);
            setUsers(response.data['hydra:member']);
            setTotalUsers(response.data['hydra:totalItems']);
        };

        fetchUser();
    }, [url]);

    function getTotalConnexions(users: UserData[]) {
        const totals: Record<string, number> = {};

        NETWORKS.forEach(network => {
            totals[network.name] = users.filter(user => user[network.key]).length;
        });

        return totals;
    }

    const totals = users ? getTotalConnexions(users) : {};

    return (
        <div className="h-full flex flex-col justify-between max-h-[300px]">
            <div className="flex items-center justify-start gap-2 w-full">
                <img className="h-[40px]" src={network} alt="networks icon" />
                <div className="text-neutral-900 text-heavy font-semibold leading-normal">
                    Mes réseaux
                </div>
            </div>
            {users ? (
                <>
                    <div className="flex flex-col justify-items-end gap-[12px] w-full">
                        {NETWORKS.map(network => (
                            <NetworkItem
                                key={network.key}
                                logo={network.logo}
                                displayName={network.displayName}
                                variant="count"
                                count={totals[network.name] || 0}
                                totalCount={totalUsers}
                                sizeClass="medium"
                            />
                        ))}
                    </div>
                </>
            ) : (
                <p>Chargement...</p>
            )}
        </div>
    );
};

export default NetworkAdmin;
